export function normalizeColor(color) {
  if (!color || typeof color !== 'string') return null;

  // Удаляем все пробелы и приводим к нижнему регистру
  const cleanColor = color.replace(/\s+/g, '').toLowerCase();

  // 1. Проверяем HEX (#fff, fff, #ffffff, ffffff)
  if (/^#?([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(cleanColor)) {
    let hex = cleanColor.replace('#', '');

    // Упрощённый HEX (#abc → #aabbcc)
    if (hex.length === 3 || hex.length === 4) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('');
    }

    // Добавляем #, если его нет
    return `#${hex}`;
  }

  // 2. Проверяем RGB/RGBA (rgb(255,255,255), rgba(255,255,255,0.5))
  const rgbaMatch = cleanColor.match(
    /^rgba?\((\d{1,3}),(\d{1,3}),(\d{1,3})(?:,([\d.]+))?\)$/
  );
  if (rgbaMatch) {
    const r = Math.min(255, parseInt(rgbaMatch[1]));
    const g = Math.min(255, parseInt(rgbaMatch[2]));
    const b = Math.min(255, parseInt(rgbaMatch[3]));
    const a = rgbaMatch[4] !== undefined ? parseFloat(rgbaMatch[4]) : 1;

    if (a === 1) {
      return `rgb(${r},${g},${b})`; // Если альфа=1, возвращаем rgb()
    } else {
      return `rgba(${r},${g},${b},${a})`; // Иначе rgba()
    }
  }

  // 3. Проверяем числа через запятую (255,255,255 или 255,255,255,0.5)
  const numbersMatch = cleanColor.match(
    /^(\d{1,3}),(\d{1,3}),(\d{1,3})(?:,([\d.]+))?$/
  );
  if (numbersMatch) {
    const r = Math.min(255, parseInt(numbersMatch[1]));
    const g = Math.min(255, parseInt(numbersMatch[2]));
    const b = Math.min(255, parseInt(numbersMatch[3]));
    const a = numbersMatch[4] !== undefined ? parseFloat(numbersMatch[4]) : 1;

    if (a === 1) {
      return `rgb(${r},${g},${b})`; // Если альфа=1, возвращаем rgb()
    } else {
      return `rgba(${r},${g},${b},${a})`; // Иначе rgba()
    }
  }

  // 4. Если формат не распознан, возвращаем color
  return color;
}
